import TaskSettingService from "@/services/api/TaskSetting";
import { handleResponse } from "@/services/axios";
import { createAsyncThunk, createSlice, isFulfilled, isPending, isRejected, isRejectedWithValue } from "@reduxjs/toolkit";

interface TaskFielState {
    taskSettings: any[];
    isFetching: boolean;
    error: string | null;
}
const initialState: TaskFielState = {
    taskSettings: [],
    isFetching: false,
    error: null
}

export const getTaskSettingFields = createAsyncThunk(
    "tasksetting/getSettings",
    async (_, { rejectWithValue }) => {
        try {
            const response = await TaskSettingService.getTaskSettings();
            return handleResponse(response, rejectWithValue);
        } catch (err: any) {
            return rejectWithValue(err?.Message || "Failed to fetch task setting fields");
        }
    }
);

export const addTaskSettingField = createAsyncThunk(
    "addtasksetting",
    async (data: any, { rejectWithValue }) => {
        try {            
            const response = await TaskSettingService.addTaskSetting(data);
            return handleResponse(response, rejectWithValue);
        } catch (err: any) {
            return rejectWithValue(err?.Message || "Failed to add task setting  field");
        }
    }
);


export const deleteTaskSettingField = createAsyncThunk(
    "taskSettings/deleteTaskSettingField",
    async (id: any, { rejectWithValue }) => {
        try {
            const response = await TaskSettingService.deleteTaskSetting(id);
            return handleResponse(response, rejectWithValue);
        } catch (err: any) {
            return rejectWithValue(
                err?.Message || "Failed to delete task setting field"
            );
        }
    }
);

const taskSettingSlice = createSlice({
    name: "taskSettings",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getTaskSettingFields.fulfilled, (state, Action) => {
            state.taskSettings = Action.payload;
        }) //get 
            //add
            .addCase(addTaskSettingField.fulfilled, (state, action) => {
                state.taskSettings.push(action.payload);
            })
            .addCase(deleteTaskSettingField.fulfilled, (state, action) => {
                state.taskSettings = state.taskSettings.filter((t) => t.Id !== action.payload);
            });//delete



        //generic handlers 
        // calls
        builder.addMatcher(isPending, (state) => {
            state.isFetching = true;
            state.error = null;
        });

        //  fails
        builder.addMatcher(isRejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload as string;
        });

        // succeeds
        builder.addMatcher(isFulfilled, (state) => {
            state.isFetching = false;
        });
    }
}) ;


export default taskSettingSlice.reducer;